import { PartyStore } from "../../store/PartyStore.js";
import { WorldStore } from "../../store/WorldStore.js";
import { SessionStore } from "../../store/SessionStore.js";
import type { PartyStoreJSON } from "../../store/PartyStore.js";
import type { WorldStoreJSON } from "../../store/WorldStore.js";
import type { SessionStoreJSON } from "../../store/SessionStore.js";

// ── Aggregate snapshot type ───────────────────────────────────────────────────

/**
 * Plain-data snapshot of every module-singleton store (P01).
 * Consumed by the SaveFile type (P02) and PersistenceManager (P03).
 * All fields are JSON-serializable — no Sets, Maps, or class instances.
 */
export interface StoreSnapshot {
  readonly party: PartyStoreJSON;
  readonly world: WorldStoreJSON;
  readonly session: SessionStoreJSON;
}

// ── Orchestration helpers ─────────────────────────────────────────────────────

/**
 * Capture current state from all three stores into a plain-data snapshot.
 * Call this immediately before writing a save to IndexedDB.
 */
export function snapshotStores(): StoreSnapshot {
  return {
    party: PartyStore.toJSON(),
    world: WorldStore.toJSON(),
    session: SessionStore.toJSON(),
  };
}

/**
 * Restore all three stores from a snapshot.
 * Replaces every store's state wholesale — call this after reading a save
 * and before rebuilding the scene.
 */
export function restoreStores(snapshot: StoreSnapshot): void {
  PartyStore.loadJSON(snapshot.party);
  WorldStore.loadJSON(snapshot.world);
  SessionStore.loadJSON(snapshot.session);
}
